import React, { useState, useEffect } from "react";
import { Row, Col, Form, Card, Button } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { fileUpload, editPost, particularPost } from "../../../common/api";
import { ShowToast } from "../../../common/function";
import ConfigApp from "../../../common/config";
import { Spinner } from "react-activity";

export default function Editpost() {
  const location = useLocation();
  const postId = location.state.postId;
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState("select");
  const [websiteLink, setWebsiteLink] = useState("");
  const [previewImages, setPreviewImages] = useState([]);
  const [uploadedImagePaths, setUploadedImagePaths] = useState([]);
  const [errors, setErrors] = useState({});
  const [uploading, setUploading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchPost = async () => {
      const token = localStorage.getItem("token");
      const response = await particularPost(token, { postId });
      if (response.success) {
        const data = response.body;
        setTitle(data.about_post || "");
        setDescription(data.about_post || "");
        setWebsiteLink(data.web_link || "");
        setStatus(data.status =='active' ? "active" : "inactive" || "select");
        setUploadedImagePaths( data.media_url && data.media_url.length>0 ?  data.media_url : []);
        setPreviewImages( data.media_url && data.media_url.length>0 ?  data.media_url.map((url) => ConfigApp.URL+url) : []);
      }
    };
    fetchPost();
  }, [postId]);

  const handleImageChange = async (e) => {
    const selectedFiles = Array.from(e.target.files);
    if (uploadedImagePaths.length + selectedFiles.length > 3) {
      setErrors((prev) => ({ ...prev, images: "You can only upload up to 3 images." }));
      return;
    }
  
    setUploading(true);
  
    for (const file of selectedFiles) {
      try {
        const token = localStorage.getItem("token");
        const formData = new FormData();
        formData.append("images[]", file);
  
        const res = await fileUpload(token, formData);
        if (res.success) {
          // ✅ Push only the string (not array or object)
          const path = Array.isArray(res.body) ? res.body[0] : res.body;
          setUploadedImagePaths((prev) => [...prev, path]);
          setPreviewImages((prev) => [...prev, URL.createObjectURL(file)]);
        } else {
          setErrors((prev) => ({ ...prev, images: "Failed to upload some image(s)." }));
        }
      } catch (err) {
        setErrors((prev) => ({ ...prev, images: "Upload error occurred." }));
      }
    }
  
    setUploading(false);
    e.target.value = "";
  };
  
  

  const handleRemoveImage = (index) => {
    const newPreview = [...previewImages];
    const newPaths = [...uploadedImagePaths];
    newPreview.splice(index, 1);
    newPaths.splice(index, 1);
    setPreviewImages(newPreview);
    setUploadedImagePaths(newPaths);
  };

  const handleValidation = () => {
    let tempErrors = {};
    // if (!title.trim()) tempErrors.title = "Post title is required";
    if (!description.trim()) tempErrors.description = "About post is required";
  
    if (websiteLink.trim()) {
      const urlPattern = /^(https?:\/\/)?([\w\d-]+\.)+[\w\d]{2,}(\/.*)?$/i;
      if (!urlPattern.test(websiteLink.trim())) {
        tempErrors.websiteLink = "Enter a valid website URL (e.g. https://example.com)";
      }
    }
    
    if (status === "select") tempErrors.status = "Please select a status";
    if (uploadedImagePaths.length === 0) tempErrors.images = "Please upload at least one image";
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!handleValidation()) return;
    const token = localStorage.getItem("token");
    setIsLoading(true)
    const formData = {
      postId,
      about_post: description,
      web_link: websiteLink,
      media_url: uploadedImagePaths,
      status,
    };
    console.log("formData",formData);
    
    const response = await editPost(token, formData);
    setIsLoading(false)
    if (response.success) {
      ShowToast(1, "Post updated successfully");
      navigate("/posts");
    } else {
      ShowToast(0, response.message);
    }
  };



  return (
    <Card>
      <Card.Header className="d-flex align-items-center justify-content-between flex-wrap">
        <h5>Edit Post</h5>
        <Link className="btn btn-primary2 px-4 min_width140" to="/posts">
          Back
        </Link>
      </Card.Header>
      <Card.Body>
        <Row className="mt-3">
          <Col md={5} xl={4} className="view_profile mb-3">
            <div className="user_info text-center">
              <div className="d-flex justify-content-center flex-wrap gap-2">
                {[0, 1, 2].map((i) => (
                  <div
                    key={i}
                    style={{
                      position: "relative",
                      width: "80px",
                      height: "80px",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      backgroundColor: "#f8f9fa",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {previewImages[i] ? (
                      <>
                        <img
                          src={previewImages[i]}
                          alt={`preview-${i}`}
                          style={{ width: "100%", height: "100%", objectFit: "cover" }}
                        />
                        <span
                          onClick={() => handleRemoveImage(i)}
                          style={{
                            position: "absolute",
                            top: "-6px",
                            right: "-6px",
                            background: "red",
                            color: "#fff",
                            borderRadius: "50%",
                            width: "18px",
                            height: "18px",
                            fontSize: "12px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                          }}
                        >
                          ×
                        </span>
                      </>
                    ) : (
                      <span style={{ fontSize: "12px", color: "#aaa" }}>No Image</span>
                    )}
                  </div>
                ))}
              </div>
              <label htmlFor="uploadcoverimg" className="d-inline-block mt_30 btn btn-primary-outline px-4 font-size-14 lh-40">
                Upload Cover Images
              </label>
              <input
                type="file"
                id="uploadcoverimg"
                className="d-none"
                accept="image/*"
                multiple
                onChange={handleImageChange}
              />
              {errors.images && <p className="text-danger mt-2">{errors.images}</p>}
              {uploading && <p className="text-primary mt-2">Uploading...</p>}
            </div>
          </Col>

          <Col md={7} xl={8}>
            <Form className="mb-5" onSubmit={handleSubmit}>
              <Row>
                {/* <Col lg={12}>
                  <Form.Group className="form-group mb-3">
                    <Form.Label>About Post</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter about post"
                      value={title}
                      onChange={(e) => {
                        setTitle(e.target.value);
                        setErrors((prev) => ({ ...prev, title: "" }));
                      }}
                    />
                    {errors.title && <p className="text-danger">{errors.title}</p>}
                  </Form.Group>
                </Col> */}
                <Col lg={12}>
                  <Form.Group className="form-group mb-3">
                    <Form.Label>About Post</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={6}
                      placeholder="Enter about post"
                      value={description}
                      onChange={(e) => {
                        setDescription(e.target.value);
                        setErrors((prev) => ({ ...prev, description: "" }));
                      }}
                    />
                    {errors.description && <p className="text-danger">{errors.description}</p>}
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="form-group mb-3">
                    <Form.Label>Website link</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter website link"
                      value={websiteLink}
                      onChange={(e) => {
                        setWebsiteLink(e.target.value);
                        setErrors((prev) => ({ ...prev, websiteLink: "" }));
                      }}
                    />
                    {errors.websiteLink && <p className="text-danger">{errors.websiteLink}</p>}
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="form-group mb-3">
                    <Form.Label>Status</Form.Label>
                    <Form.Select
                      value={status}
                      onChange={(e) => {
                        setStatus(e.target.value);
                        setErrors((prev) => ({ ...prev, status: "" }));
                      }}
                    >
                      <option value="select">Select Status</option>
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </Form.Select>
                    {errors.status && <p className="text-danger">{errors.status}</p>}
                  </Form.Group>
                </Col>
              </Row>
              <Button type="submit" className="btn btn-primary px-4 mt-3 min_width140" disabled={isLoading}>
                {isLoading ? (
                  <Spinner animation="border" variant="primary" size={15} />
                ) : (
                  "Update Post"
                )}
              </Button>
            </Form>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}
